export const userClicksOnAppleDownloadButton = () => ({
  type: 'App Apple Download Clicked',
});

export const userClicksOnGoogleDownloadButton = () => ({
  type: 'App Google Download Clicked',
});
